<form [formGroup]="vehicleForm">
  <!-- Fila 1: Estado + Unidades (col-6 mobile, col-4 desktop) -->
  <div class="row">
    <div class="col-6 col-xl-4 mb-3">
      <label for="vehicle_status" class="form-label">{{
        "inputs.status" | translate
      }}</label>
      <ng-select formControlName="vehicle_status" [items]="vehicleStatusOptions" bindValue="key"
        [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate">
        <ng-template ng-label-tmp let-item="item">
          {{ "badge-status_select-stage." + item.key | translate }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ "badge-status_select-stage." + item.key | translate }}
        </ng-template>
      </ng-select>
    </div>
    <div class="col-6 col-xl-4 mb-3">
      <label for="vehicle_units" class="form-label">{{
        "inputs.vehicle_units" | translate
      }}</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="vehicle_units"
          required
          formControlName="vehicle_units"
          placeholder="{{ 'inputs.vehicle_units' | translate }}"
        />
      </div>
    </div>
    <div
      class="col-12 col-xl-4 mb-3 div-download"
      *ngIf="orderData?.vehicle_units > 1"
    >
      <label class="form-label subtext"
        ><em
          >{{ "forms.labels.duplicate_orders_text1" | translate
          }}<a class="a_pulsable" (click)="duplicate()">{{
            "forms.labels.duplicate_orders_text2"
              | translate: { unidades: orderData?.vehicle_units }
          }}</a>
          {{ "forms.labels.duplicate_orders_text3" | translate }}</em
        ></label
      >
    </div>
  </div>
  <div class="row linea"></div>
  <!-- Fila 2: Marca + Modelo + Versión + Año (col-3 fijo) -->
  <div class="row">
    <div class="col-3 mb-3">
      <label for="brand" class="form-label"
        >{{ "inputs.brand" | translate }} <span class="required">*</span></label
      >
      <ng-select formControlName="vehicle_brand_id" [items]="brands" bindValue="reference" bindLabel="name"
        [placeholder]="'inputs.brand' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate" (change)="onBrandChange($event)">
      </ng-select>
    </div>
    <div class="col-3 mb-3">
      <label for="model" class="form-label"
        >{{ "inputs.model" | translate }} <span class="required">*</span></label
      >
      <ng-select formControlName="vehicle_model_id" [items]="models" bindValue="reference" bindLabel="name"
        [placeholder]="'inputs.model' | translate" [searchable]="true" [clearable]="false"
        [notFoundText]="'tables.no_results' | translate">
      </ng-select>
    </div>
    <div class="col-3 mb-3">
      <label for="vehicle_trim" class="form-label">{{
        "inputs.vehicle_trim_finish" | translate
      }}</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="vehicle_trim"
          formControlName="vehicle_trim"
          maxlength="150"
        />
      </div>
    </div>
    <div class="col-3 mb-3">
      <label for="year" class="form-label">{{
        "inputs.year" | translate
      }}</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="vehicle_model_year"
          required
          formControlName="vehicle_model_year"
          placeholder="{{ 'inputs.year_model' | translate }}"
        />
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 mb-3">
      <label for="vehicle" class="form-label">{{
        "inputs.vehicle_trim" | translate
      }}</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="vehicle"
          required
          formControlName="vehicle"
          placeholder="{{ 'inputs.vehicle_trim' | translate }}"
        />
      </div>
    </div>
  </div>
  <!-- Fila 4: Tapicería + Color (col-6), Emisiones (col-6 abajo). Desktop: 3x col-4 -->
  <div class="row">
    <div class="col-6 col-xl-4 mb-3">
      <label for="vehicle_upholstery" class="form-label">{{
        "inputs.vehicle_upholstery" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="vehicle_upholstery"
          required
          formControlName="vehicle_upholstery"
          placeholder="{{ 'inputs.vehicle_upholstery' | translate }}"
        />
      </div>
    </div>
    <div class="col-6 col-xl-4 mb-3">
      <label for="colour" class="form-label">{{
        "inputs.colour" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="colour"
          required
          formControlName="colour"
          placeholder="{{ 'inputs.colour' | translate }}"
        />
      </div>
    </div>
    <div class="col-6 col-xl-4 mb-3">
      <label for="vehicle_co2_emissions" class="form-label">{{
        "inputs.vehicle_co2_emissions" | translate
      }}</label>
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="vehicle_co2_emissions"
          required
          formControlName="vehicle_co2_emissions"
          placeholder="{{ 'inputs.vehicle_co2_emissions' | translate }}"
        />
      </div>
    </div>
  </div>

  <div class="row linea"></div>
  <div class="row" *ngIf="showAlertVin">
    <div class="col-12">
      <div class="alert alert-warning alert-dismissible fade show" role="alert">
        <div>
          <span
            >{{ "filter.part1" | translate }}
            {{ "filter.vin.part1" | translate }}
            <strong>
              <a [href]="urlVin" target="_blank">
                {{ "filter.part5" | translate }}
              </a>
            </strong></span
          >
        </div>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="showAlertLicensePlate">
    <div class="col-12">
      <div class="alert alert-warning alert-dismissible fade show" role="alert">
        <div>
          <span
            >{{ "filter.part1" | translate }}
            {{ "filter.license-plate.part1" | translate }}
            <strong>
              <a [href]="urlLicensePlate" target="_blank">
                {{ "filter.part5" | translate }}
              </a>
            </strong>
          </span>
        </div>
      </div>
    </div>
  </div>
  <!-- Fila 5: Bastidor + Matrícula (col-6 fijo) -->
  <div class="row">
    <div class="col-6 mb-3">
      <label for="vin" class="form-label">{{ "inputs.vin" | translate }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="vin"
          required
          formControlName="vin"
          placeholder="{{ 'inputs.vin' | translate }}"
          #inputFieldvin
          (blur)="onBlurVin(inputFieldvin.value)"
        />
        <div class="input-group-append" *ngIf="availableVins.length > 0">
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="openVinSelector()"
            title="{{ 'bastidores.select_from_stock' | translate }}"
          >
            <i class="icon-list"></i>
          </button>
        </div>
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="copyToClipboard(inputFieldvin.value, $event)"
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="col-6 mb-3">
      <label for="license_plate" class="form-label">{{
        "inputs.license_plate" | translate
      }}</label>
      <div class="input-group div-copy">
        <input
          type="text"
          class="form-control"
          id="license_plate"
          required
          formControlName="license_plate"
          placeholder="{{ 'inputs.license_plate' | translate }}"
          #inputFieldplate
          (blur)="onBlurLicensePlate(inputFieldplate.value)"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-secondary copy"
            type="button"
            (click)="copyToClipboard(inputFieldplate.value, $event)"
          >
            <i class="icon-copy"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Fila 6: Kilometraje + Fecha (col-6 fijo) -->
  <div class="row">
    <div class="col-6 mb-3">
      <label for="vehicle_mileage" class="form-label">{{
        "inputs.vehicle_mileage" | translate
      }}</label>
      <div class="input-group">
        <div class="currencydiv">
          <input
            type="text"
            class="form-control"
            id="vehicle_mileage"
            required
            formControlName="vehicle_mileage"
            placeholder="{{ 'inputs.vehicle_mileage' | translate }}"
          />
          <span> kms</span>
        </div>
      </div>
    </div>
    <div class="col-6 mb-3">
      <label for="vehicle_registration_date" class="form-label">{{
        "inputs.vehicle_registration_date" | translate
      }}</label>
      <span class="info-icon" tabindex="0">
        <i class="icon-notification"></i>
        <span class="tooltip">{{
          "inputs.i.vehicle_registration_date" | translate
        }}</span>
      </span>
      <div class="input-group">
        <mat-form-field appearance="fill">
          <input
            matInput
            [matDatepicker]="vehicle_registration_date"
            formControlName="vehicle_registration_date"
            placeholder="{{ 'inputs.vehicle_registration_date' | translate }}"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="vehicle_registration_date"
          ></mat-datepicker-toggle>
          <mat-datepicker #vehicle_registration_date></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="row linea"></div>

  <div class="row">
    <!-- Fila 7: Precio (col-12 mobile, col-6 desktop) -->
    <div class="col-12 col-xl-6 mb-3">
      <label for="vehicle_retail_price" class="form-label">{{
        "inputs.vehicle_retail_price" | translate
      }}</label>
      <div class="input-group">
        <div class="currencydiv">
          <input
            type="text"
            class="form-control"
            id="vehicle_retail_price"
            required
            formControlName="vehicle_retail_price"
            placeholder="{{ 'inputs.vehicle_retail_price_pvp' | translate }}"
          />
          <span> EUR</span>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="formulario-sub-derecha-container vin-selector-panel" [ngClass]="{ 'mostrar-formulario': showVinSelector }">
  <app-vin-selector
    *ngIf="showVinSelector"
    [availableVins]="availableVins"
    (vinSelected)="onVinSelected($event)"
    (closeSelector)="closeVinSelector()"
  ></app-vin-selector>
</div>
